var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dialog",on:{"click":_vm.nextDialog}},[_c('Replica',{attrs:{"character":_vm.currentReplica.id,"name":_vm.npc[_vm.currentReplica.id].name}},[_vm._v(" "+_vm._s(_vm.currentReplica.text)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }